import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Seo from "@/components/Seo";
import { landingSchema, LANDING_TITLE, LANDING_DESCRIPTION } from "@/lib/landingSeo";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import LogoMarquee from "@/components/site/LogoMarquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import CaseStudies from "@/components/site/CaseStudies";
import Process from "@/components/site/Process";
import GuaranteeBanner from "@/components/site/GuaranteeBanner";
import Testimonials from "@/components/site/Testimonials";
import LogoWall from "@/components/site/LogoWall";
import LeadMagnet from "@/components/site/LeadMagnet";
import BookingForm from "@/components/site/BookingForm";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-[#070B14] text-white font-[Manrope,sans-serif] overflow-x-hidden">
        <Seo
          title={LANDING_TITLE}
          description={LANDING_DESCRIPTION}
          path="/"
          keywords="dental marketing agency, dental marketing, marketing for dentists, dental leads, new patient acquisition, dental google ads, dental seo, Dental Leads Lab"
          schema={landingSchema}
        />
        <Nav />
        <main>
          <Hero />
          <LogoMarquee />
          <Manifesto />
          <Services />
          <Stats />
          <CaseStudies />
          <Process />
          <GuaranteeBanner />
          <Testimonials />
          <LogoWall />
          <LeadMagnet />
          <BookingForm />
          <Faq />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
